import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Temperature = ({ textData ,language}) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text36']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text37']),
          }}
        ></h5>
      </div>

      <div className={styles.paramsBox}>
        <video
          data-fade-in-play={true}
          playsInline
          muted
          preload={true}
          src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-rgb.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-rgb-cover.jpg"
        ></video>
        <div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text38']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text39']),
              }}
              className="mainText"
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text40']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text41']),
              }}
              className="mainText"
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text42']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text43']),
              }}
              className="mainText"
            ></h3>
          </div>
        </div>
      </div>

      <video
        data-fade-in-play={true}
        playsInline
        muted
        preload={true}
        src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-rgb${language === 'cn' ? '' : '-en'}.mp4`}
        poster={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-rgb-cover${language === 'cn' ? '' : '-en'}.jpg`}
      ></video>
    </div>
  );
};

export default Temperature;
